import React, {useState} from "react";
import {Workbox} from "workbox-window";
import {Button, Snackbar, SnackbarContent} from "@mui/material";

export function WorkboxUpdateNotifier() {
    const [updated, setUpdated] = useState(false)

    if ('serviceWorker' in navigator) {
        const wb = new Workbox('/service-worker.js');

        wb.addEventListener('installed', event => {
            if (event.isUpdate) {
                setUpdated(true)
            }
        });

        wb.register();
    }

    if (!updated) {
        return (<></>)
    }

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            open
        >
            <SnackbarContent
                style={{background: '#22313f'}}
                message={
                    'UI update installed. Refresh to apply.'
                }
                action={<Button color="secondary" variant='contained' size="small"
                                onClick={() => window.location.reload()}>
                    Refresh
                </Button>}
            />
        </Snackbar>
    )
}